import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './ui/labels/__generated__/labels_issueFieldLabelsEditviewFull_LabelsEditViewQuery.graphql';

type EntryPointParams = { id?: string };

const LabelsEditViewEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-labels-edit-view" */ './ui/labels'),
	),
	getPreloadProps: ({ id }: EntryPointParams) =>
		id
			? {
					queries: {
						labelsSuggestionsData: {
							parameters,
							options: {
								fetchPolicy: 'store-or-network' as const,
							},
							variables: {
								id,
							},
						},
					},
				}
			: {},
});

export default LabelsEditViewEntryPoint;
